export default {
  bestOffer: {
    en: 'Best Offer:',
  },
  almostThere: {
    en: 'Almost there!',
  },
  yay: {
    en: 'YAY!',
  },
  getFree: {
    en: 'GET <span class="text-bold">Free</span> Deluxe Bag',
  },
  unlocked: {
    en: 'deluxe bag is <span class="text-bold">UNLOCKED</span>!',
  },
  addMore: {
    en: 'Add just {count} more product',
  },
  itWasAdded: {
    en: 'It’s added to your shipment',
  },
}
